import { render, staticRenderFns } from "./FilledSection.vue?vue&type=template&id=20c46ab3"
import script from "./FilledSection.vue?vue&type=script&lang=js"
export * from "./FilledSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports